import React from 'react';
import { useComponents } from '@tencent/dz-elements';
import styles from './style/index.less';
export var FormContainer = function (props) {
    var View = useComponents().View;
    var _a = props.tips, tips = _a === void 0 ? [] : _a, title = props.title, children = props.children;
    var renderTips = function () { return tips.map(function (tip, index) { return (React.createElement(View, { className: styles['form-tip-item'], key: index }, tip)); }); };
    return (React.createElement(View, { className: styles['form-wrapper'] },
        React.createElement(View, { className: styles['form-head'] },
            title && React.createElement(View, { className: styles['form-title'] }, title),
            tips && tips.length > 0 && React.createElement(View, { className: styles['form-tips'] }, renderTips())),
        React.createElement(View, { className: styles['form-container'] }, children)));
};
